import axios from 'axios';
import config from '../config';
import { createPaymentClient, ShareScope, Transport } from './contracts';
const transport: Transport = async <T>(method: string, path: string, body?: unknown, headers?: Record<string, string>) => {
  const response = await axios.request<T>({ method, url: `${config.apiBaseUrl}${path}`, data: body, headers, timeout: 20000 });
  return response.data;
};
export const sharedPaymentClient = (scope: ShareScope) => createPaymentClient(transport, scope);
let configuration: Promise<{ repayment: boolean }> | undefined;
export function paymentFeatures() {
  // Deduplicate concurrent reads, but never turn an outage into a Venmo-only
  // rollout decision or keep an old decision for the lifetime of the tab.
  if (!configuration) configuration = transport<{ repayment: boolean }>('GET', '/v2/config').then(result => {
    if (typeof result.repayment !== 'boolean') throw new Error('Couldn’t load payment options.');
    return result;
  }).finally(() => { configuration = undefined; });
  return configuration;
}
